<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        el-form.form.p-2(label-position='top', size='small')
            el-form-item.produtor
                .label(slot='label')
                    span {{ $t('mensagens.comuns.pessoa') }}
                    span(v-show='this.territorio.representantes.length === 0') - {{ $t('mensagens.laudos.nenhumaPessoaVinculada') }}
                    span.erro(
                        v-if='$v.nomeRepresentante.$invalid && $v.cpfCnpjRepresentante.$invalid'
                    ) *
                el-radio(
                    v-for='(representante, index) in territorio.representantes',
                    v-model='representanteSelecionado',
                    :label='index',
                    :key='representante.cpfCnpj'
                )
                    | {{ representante.nomeRazaoSocial }} ({{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }})
                    span.espacoRepresentante
                .outro
                    el-radio(
                        v-model='representanteSelecionado',
                        :label='outroRepresentante'
                    ) {{ $t('mensagens.laudos.outro') }}:
                    .input(
                        v-if='representanteSelecionado == outroRepresentante'
                    )
                        el-input.nome(
                            v-model='outro.nome',
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')"
                        )

                        el-input.cpfCnpj(
                            v-model='outro.cpfCnpj',
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                            :class='{ "erro-borda": !cpfCnpjValido }',
                            @change='aplicarMascara()'
                        )

                    .input(v-else)
                        el-input.nome(
                            disabled,
                            :placeholder="$t('mensagens.laudos.insiraNomeOuRazaoSocialDaPessoa')"
                        )
                        el-input.cpfCnpj(
                            disabled,
                            :placeholder="$t('mensagens.laudos.documentoDaPessoa')",
                        )

            .dados
                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.refBacenOnzeDigitos') }}
                        span.erro(v-if='$v.referenciaBacen.$invalid') *
                    el-input(
                        v-model='referenciaBacen',
                        v-mask='["###########"]'
                    )

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.culturaFinanciada') }}
                        span.erro(v-if='$v.culturaId.$invalid') *
                    el-select(v-model='culturaId')
                        el-option(
                            v-for='(cultura, index) in culturas',
                            :value='cultura.id',
                            :label='cultura.nome',
                            :key='cultura.id'
                        )

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.areaFinanciada') }}
                        span.erro(v-if='$v.areaFinanciadaHa.$invalid') *
                    el-input(v-model='areaFinanciadaHa')

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.producaoEsperada') }}
                        span.erro(v-if='$v.producaoEsperadaTon.$invalid') *
                    el-input(v-model='producaoEsperadaTon')

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.produtividadeEsperada') }}
                        span.erro(v-if='$v.produtividadeEsperadaScHa.$invalid') *
                    el-input(v-model='produtividadeEsperadaScHa')

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.dataPlantio') }}
                        span.erro(v-if='$v.dataPlantio.$invalid') *
                    el-date-picker(
                        v-model='datas.plantio',
                        format='dd/MM/yyyy'
                    )

                el-form-item
                    .label(slot='label')
                        span {{ $t('mensagens.laudos.dataColheita') }}
                        span.erro(v-if='$v.dataColheita.$invalid') *
                    el-date-picker(
                        v-model='datas.colheita',
                        format='dd/MM/yyyy'
                    )
</template>

<script>
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import {
    required,
    integer,
    minLength,
    maxLength
} from 'vuelidate/lib/validators';
import TipoLaudo from '@/constants/TipoLaudo';

import BaseButton from '@/components/vegaComponents/BaseButton.vue';

const isNumber = value => !isNaN(value.toString().replace(',', '.'));
const OUTRO_REPRESENTANTE = '42';

export default {
    name: 'CardDadosTerritorio',

    components: {
        BaseButton
    },

    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        },
        culturas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            collapse: ['item'],

            representanteSelecionado: '',
            outro: {
                nome: '',
                cpfCnpj: ''
            },
            outroRepresentante: OUTRO_REPRESENTANTE,

            datas: {
                plantio: null,
                colheita: null
            },

            referenciaBacen: '',
            areaFinanciadaHa: '',
            producaoEsperadaTon: '',
            produtividadeEsperadaScHa: '',
            dataPlantio: '',
            dataColheita: '',
            nomeRepresentante: '',
            cpfCnpjRepresentante: '',
            culturaId: '',
            tipoLaudoId: '',
            cpfCnpjValido: true
        };
    },

    mounted() {
        if (this.territorio.representantes.length === 0) {
            this.representanteSelecionado = OUTRO_REPRESENTANTE;
        }
        this.areaFinanciadaHa = this.territorio.areaHa
            .toFixed(2)
            .toString()
            .replace('.', ',');
        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },

    watch: {
        representanteSelecionado: function () {
            // eslint-disable-next-line eqeqeq
            if (this.representanteSelecionado != OUTRO_REPRESENTANTE) {
                this.nomeRepresentante =
                    this.territorio.representantes[
                        this.representanteSelecionado
                    ].nomeRazaoSocial;
                this.cpfCnpjRepresentante =
                    this.territorio.representantes[
                        this.representanteSelecionado
                    ].cpfCnpj;
            } else {
                this.nomeRepresentante = '';
                this.cpfCnpjRepresentante = '';
            }
        },

        'outro.nome': function () {
            this.nomeRepresentante = this.outro.nome;
        },

        'outro.cpfCnpj': function () {
            if (this.outro.cpfCnpj !== '') {
                this.cpfCnpjValido = validators.validarDocumento(
                    this.outro.cpfCnpj
                );
                if (this.cpfCnpjValido) {
                    this.cpfCnpjRepresentante = this.outro.cpfCnpj;
                } else {
                    this.cpfCnpjRepresentante = '';
                }
            }
        },

        '$v.dados.$invalid': function () {
            this.$emit('getValidacao', {
                valido: !this.$v.dados.$invalid,
                id: this.territorio.id
            });
            this.$emit('getDados', {
                dados: {
                    referenciaBacen: this.referenciaBacen,
                    areaFinanciadaHa: this.areaFinanciadaHa.replace(',', '.'),
                    producaoEsperadaTon: this.producaoEsperadaTon.replace(
                        ',',
                        '.'
                    ),
                    produtividadeEsperadaScHa:
                        this.produtividadeEsperadaScHa.replace(',', '.'),
                    dataPlantio: this.dataPlantio.toISOString(),
                    dataColheita: this.dataColheita.toISOString(),
                    nomeRepresentante: this.nomeRepresentante,
                    cpfCnpjRepresentante: this.cpfCnpjFormatToNumeral(
                        this.cpfCnpjRepresentante
                    ),
                    culturaId: this.culturaId,
                    territorioId: this.territorio.id,
                    tipoLaudoId: TipoLaudo.BACEN_FISCALIZACAO,
                    tipoDocumentoRepresentante: this.cpfCnpjRepresentante.length < 11 ? 'RUC' : 'CPF_CNPJ'
                },
                id: this.territorio.id
            });
        },

        'datas.plantio': function () {
            this.validarDatas('O plantio deve ocorrer antes da colheita');
        },

        'datas.colheita': function () {
            this.validarDatas('A colheita deve ocorrer depois do plantio');
        }
    },

    validations: {
        referenciaBacen: {
            required,
            minLength: minLength(11),
            maxLength: maxLength(11),
            integer
        },
        areaFinanciadaHa: { required, isNumber },
        producaoEsperadaTon: { required, isNumber },
        produtividadeEsperadaScHa: { required, isNumber },
        dataPlantio: { required },
        dataColheita: { required },
        nomeRepresentante: { required },
        cpfCnpjRepresentante: { required },
        culturaId: { required },

        dados: [
            'referenciaBacen',
            'areaFinanciadaHa',
            'producaoEsperadaTon',
            'produtividadeEsperadaScHa',
            'dataPlantio',
            'dataColheita',
            'nomeRepresentante',
            'cpfCnpjRepresentante',
            'culturaId'
        ]
    },

    methods: {
        numeralStringFormatTocpfCnpj(value) {
            return formatters.numeralStringFormatToDocumento(value);
        },

        cpfCnpjFormatToNumeral(value) {
            return formatters.documentoFormatToNumeral(value);
        },

        validarDatas(message) {
            if (this.datas.plantio && this.datas.colheita) {
                if (
                    this.datas.plantio.getTime() > this.datas.colheita.getTime()
                ) {
                    this.$notify.error({ message });
                    this.dataPlantio = null;
                    this.dataColheita = null;
                } else {
                    this.dataColheita = this.datas.colheita;
                    this.dataPlantio = this.datas.plantio;
                }
            }
        },

        aplicarMascara() {
            this.outro.cpfCnpj = formatters.documentoFormatToNumeral(this.outro.cpfCnpj);
            this.outro.cpfCnpj = formatters.numeralStringFormatToDocumento(this.outro.cpfCnpj);
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .produtor .outro .input {
            display: flex;
            justify-content: space-between;

            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
        }

        .dados {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 8px;
            width: 100% !important;

            .el-input,
            .el-select,
            .el-date-picker {
                width: 150px;
            }
        }

        .el-radio {
            min-width: 0px !important;
        }
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
</style>
